import React from "react";
import { GrLocation } from "react-icons/gr";
import CommonModal from "../utils/commonModal";
import "./AcessLocationStyle.css";
import { FiCheck } from "react-icons/fi";
const AcessLocationPopup = ({
  isOpen,
  closeModal,
  onAllowLocation,
  loading = false,
}) => {
  const benefits = [
    <>
      Auto-fills your <strong>City You Live In</strong> field
    </>,
    "Your location is used only once and isn't tracked",
    "You can still pick your city manually anytime",
  ];

  return (
    <>
    {isOpen && 
    <CommonModal
      isOpen={isOpen}
      closeModal={closeModal}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      showCloseIcon={false}
      animationDuration={300}
      classNames={{
        root: "access_location_modal_root",
        overlay: "access_location_modal_overlay",
        modal: "access_location_modal",
        modalAnimationIn: "accessLocationModalEnter",
        modalAnimationOut: "accessLocationModalExit",
      }}
    >
      <section className="access_location_popup">
        <button
          type="button"
          className="access_location_close"
          onClick={closeModal}
          aria-label="Close location access popup"
        >
          &times;
        </button>

        <div className="access_location_icon_wrap" aria-hidden="true">
          <GrLocation className="access_location_icon" />
        </div>

        <div className="access_location_heading">Why use your current location?</div>
        <p className="access_location_subtitle">
          We'll auto-fill your city and recommend nearby colleges, exams, and
          counselling sessions.
        </p>

        <ul className="access_location_benefits">
          {benefits.map((benefit, index) => (
            <li key={index}>
              <span className="access_location_check" aria-hidden="true">
                {/* &#10003; */}
                <FiCheck />
              </span>
              <span>{benefit}</span>
            </li>
          ))}
        </ul>

        <button
          type="button"
          className="access_location_allow_btn"
          onClick={onAllowLocation}
          disabled={loading}
        >
          {"Allow location access"}
        </button>

        <p className="access_location_note">
          Your browser will ask for permission next. You can change this
          anytime in browser settings.
        </p>
      </section>
    </CommonModal>}
    </>
  );
};

export default AcessLocationPopup;
